import { AttendanceStatus } from "@prisma/client";

export const AttendeeApprovableStatuses: ExtendedAttendanceStatus[] = [
    "PENDING_APPROVAL",
    "WAITLIST",
    "INVITED",
    "REJECTED", // you can accept someone after they've been rejected
    "ATTENDING", // you can still reject someone after they've been confirmed
] as const;

// these status transitions require confirmation from the user
export const StatusUpdateConfirmationRequired: [
    ExtendedAttendanceStatus,
    ExtendedAttendanceStatus,
][] = [["ATTENDING", "REJECTED"]];

export type ExtendedAttendanceStatus =
    | AttendanceStatus
    | "REMOVED"
    | "PREAPPROVED"
    | "CHECKED IN";

export const AttendeeStatusToText: Record<ExtendedAttendanceStatus, string> = {
    PENDING_APPROVAL: "Pending Approval",
    WAITLIST: "Waitlist",
    INVITED: "Invited",
    REMOVED: "Removed",
    REJECTED: "Declined",
    PREAPPROVED: "Preapproved",
    "CHECKED IN": "Checked In",
    ATTENDING: "Attending",
    NOT_ATTENDING: "Not Attending",
    MAYBE: "Maybe",
    PROCESSING: "Processing",
    PROCESSING_PAYMENT: "Processing Payment",
    WAITLIST_AWAITING_PAYMENT: "Waitlist approved, awaiting payment",
};

export const AttendanceStatusToTailwindColor: Record<
    ExtendedAttendanceStatus,
    string
> = {
    PENDING_APPROVAL: "text-v3-S300",
    WAITLIST: "text-v3-O300",
    INVITED: "text-v3-B300",
    REJECTED: "text-v3-R300",
    REMOVED: "",
    PREAPPROVED: "text-v3-P300",
    "CHECKED IN": "text-white",
    ATTENDING: "text-v3-C300",
    NOT_ATTENDING: "text-v3-N-400",
    MAYBE: "",
    PROCESSING: "",
    PROCESSING_PAYMENT: "",
    WAITLIST_AWAITING_PAYMENT: "",
};

export const AttendanceStatusToTailwindColorBg: Record<
    ExtendedAttendanceStatus,
    string
> = {
    PENDING_APPROVAL: "bg-v3-S300/50",
    WAITLIST: "bg-v3-O300/50",
    INVITED: "bg-v3-B300/20",
    REJECTED: "bg-v3-R300/50",
    REMOVED: "",
    PREAPPROVED: "bg-v3-P300/50",
    "CHECKED IN": "bg-blue-700",
    ATTENDING: "bg-v3-C300/50",
    NOT_ATTENDING: "bg-v3-N-400/50",
    MAYBE: "",
    PROCESSING: "",
    PROCESSING_PAYMENT: "",
    WAITLIST_AWAITING_PAYMENT: "bg-v3-P500 text-center",
};

export const AttendanceStatusToTailwindColorBgFull: Record<
    ExtendedAttendanceStatus,
    string
> = {
    PENDING_APPROVAL: "bg-v3-S300",
    WAITLIST: "bg-v3-O300",
    INVITED: "bg-v3-R200",
    REJECTED: "",
    REMOVED: "",
    PREAPPROVED: "",
    "CHECKED IN": "",
    ATTENDING: "",
    NOT_ATTENDING: "",
    MAYBE: "",
    PROCESSING: "",
    PROCESSING_PAYMENT: "",
    WAITLIST_AWAITING_PAYMENT: "",
};
